// extracted by mini-css-extract-plugin
export default {"form-panel-wide":"yrknWid7z3Aeo21xQqWV","info-flex":"ymnYP5wW07ya5D82mzbq"};